import React, { useEffect } from "react";
import Cookie from "../../../../services/cookie";
import { getQueryVariable } from "../../../../apiCalls/jobInfo";
export const envMapper = {
    localhost: '.dev',
    development: '.dev',
    staging: '.stage',
   "stage-": '.stage',
   "stage": '.stage',
    prod: '',
    "dev": '.dev',
    "dev-": '.dev',
  };
const Parts = (props) => {
    let env = getQueryVariable("env");
    useEffect(()=>{
        window.addEventListener('message', (event) => {
            if(event.data.callSentToIframe == 'setKxToken'){
               Cookie.set(
                 window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN,
                 event.data.valueSentToIframe,
                 3
               );
              setTimeout(()=>{
                 window.location.href = `${event.data.url}/parts-library${window.location.search}`
             }, 0)
         }
           });
    }, [])
    return ( 
        <>Loading Pga...</>
     );
}
 
export default Parts;